/* Le Sicilianedde – facciata di Via Ferdinando Fuga 3A-3B, disegno a mano libera generato in SVG */
(function () {
  function build() {
    var s = 11;
    function rnd() { s |= 0; s = s + 0x6D2B79F5 | 0; var t = Math.imul(s ^ s >>> 15, 1 | s); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }
    function U(a, b) { return a + (b - a) * rnd(); }
    function J(a) { return U(-a, a); }
    var R = function (v) { return Math.round(v * 10) / 10; }, PI = Math.PI, L1 = [], SH = [], TX = [], FL = [];
    function poly(pts, w, o, t) { (t || L1).push('<path d="M' + pts.map(function (p) { return R(p[0]) + ' ' + R(p[1]); }).join('L') + '" stroke-width="' + R(w) + '" opacity="' + R(o) + '"/>'); }
    /* pencil line: wobbly, overshooting, drawn 2-3 times */
    function ln(x1, y1, x2, y2, w, passes) {
      w = w || 1.6; passes = passes || (w > 1.3 ? 3 : 2);
      var dx = x2 - x1, dy = y2 - y1, L = Math.hypot(dx, dy) || 1, ux = dx / L, uy = dy / L, nx = -uy, ny = ux;
      for (var p = 0; p < passes; p++) {
        var o1 = U(-3, 12), o2 = U(-3, 12), n = Math.max(2, Math.round(L / 38)), pts = [], drift = J(2.2), bow = J(L > 200 ? 4 : 2);
        var ax = x1 - ux * o1 + J(2.2), ay = y1 - uy * o1 + J(2.2), bx = x2 + ux * o2 + J(2.2), by = y2 + uy * o2 + J(2.2);
        for (var i = 0; i <= n; i++) {
          var t = i / n, k = Math.sin(t * PI) * bow + drift * t + J(.9);
          pts.push([ax + (bx - ax) * t + nx * k, ay + (by - ay) * t + ny * k]);
        }
        poly(pts, w * U(.55, 1.05), p ? U(.45, .8) : U(.8, 1));
      }
    }
    function rc(x, y, w, h, lw, ps) { ln(x, y, x + w, y, lw, ps); ln(x + w, y, x + w, y + h, lw, ps); ln(x + w, y + h, x, y + h, lw, ps); ln(x, y + h, x, y, lw, ps); }
    function el(cx, cy, rx, ry, lw, a0, a1, passes) {
      a0 = a0 || 0; a1 = a1 == null ? 2 * PI : a1; passes = passes || 2;
      for (var p = 0; p < passes; p++) {
        var n = Math.max(10, Math.round((rx + ry) / 2.2)), sh = U(-.3, .3), ext = (a1 - a0 > 6) ? U(.15, .5) : 0, pts = [];
        for (var i = 0; i <= n; i++) { var a = a0 + sh + (a1 - a0 + ext) * i / n, r = 1 + J(.012); pts.push([cx + J(.5) + rx * r * Math.cos(a), cy + J(.5) + ry * r * Math.sin(a)]); }
        poly(pts, (lw || 1.3) * U(.6, 1), p ? .6 : .95);
      }
    }
    /* chalky smudge shading */
    function sm(x1, y1, x2, y2, w) { poly([[x1 + J(3), y1 + J(3)], [(x1 + x2) / 2 + J(4), (y1 + y2) / 2 + J(4)], [x2 + J(3), y2 + J(3)]], w, U(.5, .9), SH); }
    function shadeV(x, y0, y1, w) { for (var i = 0; i < 3; i++) sm(x + J(w / 4), y0 + U(0, 30), x + J(w / 4), y1 - U(0, 30), w * U(.5, 1)); }
    function shadeH(x0, x1, y, w) { for (var i = 0; i < 2; i++) sm(x0 + U(0, 30), y + J(w / 5), x1 - U(0, 30), y + J(w / 5), w * U(.5, 1)); }
    function tx(x, y, str, size, cls, extra) { TX.push('<text x="' + x + '" y="' + y + '" font-size="' + size + '" text-anchor="middle" class="' + cls + '" ' + (extra || '') + '>' + str + '</text>'); }

    var G = 830, T = 290, B = 790;
    /* building lines */
    ln(10, 112, 1390, 112, 1.6); ln(10, 146, 1390, 146, 2);
    ln(40, 96, 40, G + 8, 1.7); ln(1360, 96, 1360, G + 8, 1.7);
    ln(0, G, 1400, G, 1.9); ln(30, G + 28, 1370, G + 26, 1, 1);
    shadeH(30, 1370, 128, 22);
    for (var y = 40; y < 100; y += 16) { ln(70 + U(0, 80), y, 320 + U(0, 160), y + J(3), .6, 1); ln(940 + U(0, 80), y, 1180 + U(0, 150), y + J(3), .6, 1); }
    function pillar(x0, x1) {
      ln(x0, 146, x0, G, 1.4); ln(x1, 146, x1, G, 1.4);
      var yy = 300;
      while (yy < G - 25) { ln(x0, yy, x1, yy + J(2), .8, 1); var mid = x0 + (x1 - x0) * ((Math.floor(yy / 60) % 2) ? .35 : .65); ln(mid, yy, mid, Math.min(yy + 62, G), .7, 1); yy += 62 + U(-5, 5); }
      shadeV((x0 + x1) / 2, 300, G, (x1 - x0) * .7);
    }
    pillar(40, 82); pillar(680, 720); pillar(1318, 1360);
    ln(82, G - 12, 680, G - 12, 1.1); ln(720, G - 12, 1318, G - 12, 1.1);
    rc(683, 372, 34, 26, 1.1, 2); tx(700, 391, '3A', 15, 'num');
    rc(1322, 372, 34, 26, 1.1, 2); tx(1339, 391, '3B', 15, 'num');
    el(700, 466, 13, 13, 1.1); ln(691, 475, 709, 457, 1, 2);

    function sign(x0, x1) {
      FL.push('<path d="M' + R(x0 + 3 + J(2)) + ' ' + R(169 + J(2)) + 'L' + R(x1 - 3 + J(2)) + ' ' + R(168 + J(2)) + 'L' + R(x1 - 2 + J(2)) + ' ' + R(268 + J(2)) + 'L' + R(x0 + 2 + J(2)) + ' ' + R(267 + J(2)) + 'Z"/>');
      rc(x0, 166, x1 - x0, 104, 1.9); ln(x0 + 9, 176, x1 - 9, 176, .9, 1); ln(x0 + 9, 260, x1 - 9, 260, .9, 1);
      var cx = (x0 + x1) / 2;
      for (var k = 0; k < 2; k++) TX.push('<g transform="translate(' + R(cx + J(1.2)) + ' ' + R(232 + J(1)) + ') scale(0.64 1) rotate(' + R(J(.4)) + ')"><text x="0" y="0" font-size="56" text-anchor="middle" class="logo' + (k ? ' logo2' : '') + '">le SICILIANEDDE</text></g>');
      tx(cx, 255, 'DOLCERIA · GELATERIA · CAFFETTERIA', 13.5, 'sub', 'letter-spacing="2.5"');
      ln(cx - 212, 250, cx - 184, 250, .9, 1); ln(cx + 184, 250, cx + 212, 250, .9, 1);
      shadeV(x0 + 30, 172, 266, 36); shadeV(x1 - 30, 172, 266, 36);
    }
    sign(92, 670); sign(730, 1308);

    function glass(x0, x1) {
      var cx = (x0 + x1) / 2;
      rc(x0, T, x1 - x0, B - T, 1.9); rc(x0 + 12, T + 12, x1 - x0 - 24, 372, 1.1, 2);
      ln(x0 + 28, T + 230, x0 + 120, T + 120, .7, 1); ln(x0 + 48, T + 262, x0 + 150, T + 140, .6, 1);
      [x0 + 42, cx, x1 - 42].forEach(function (lx, i) { var ly = T + 46 + (i % 2) * 24; ln(lx, T + 12, lx, ly - 9, .7, 1); el(lx, ly, 9, 9, 1); });
      var vt = T + 190;
      rc(x0 + 24, vt, x1 - x0 - 48, 160, 1.4);
      ln(x0 + 24, vt + 54, x1 - 24, vt + 54, .9, 1); ln(x0 + 24, vt + 106, x1 - 24, vt + 106, .9, 1);
      for (var row = 0; row < 3; row++) {
        var yy = vt + 42 + row * 52, xx = x0 + 42;
        while (xx < x1 - 62) {
          if (row == 2) poly([[xx, yy], [xx + 6, yy - 9], [xx + 14, yy - 13], [xx + 22, yy - 9], [xx + 28, yy]], 1, .9);
          else { el(xx + 13, yy - 7, 13, 6, 1, 0, 2 * PI, 1); ln(xx, yy - 7, xx + 26, yy - 7, .6, 1); }
          xx += 38 + U(-4, 4);
        }
      }
      var kt = T + 398;
      rc(x0 + 12, kt, x1 - x0 - 24, B - kt - 12, 1.2, 2);
      var oy = kt + (B - kt - 12) / 2;
      for (var a = 0; a < 4; a++) el(cx + 11 * Math.cos(a * PI / 2), oy + 11 * Math.sin(a * PI / 2), 7, 7, .9, 0, 2 * PI, 1);
      shadeV(x0 + 8, T + 10, B - 10, 14); shadeV(x1 - 8, T + 10, B - 10, 14);
    }
    function door(x0, x1, hinge) {
      var cx = (x0 + x1) / 2, aw = (x1 - x0) * .3;
      rc(x0, T, x1 - x0, B - T, 1.9);
      ln(cx - aw, 560, cx - aw, 418, 1.1); ln(cx + aw, 560, cx + aw, 418, 1.1);
      el(cx, 418, aw, aw * .72, 1.1, PI, 2 * PI);
      [452, 494, 536].forEach(function (yy) { ln(cx - aw + 6, yy, cx + aw - 6, yy, .7, 1); for (var b = 0; b < 4; b++) { var bx = cx - aw + 20 + b * (2 * aw - 40) / 3; rc(bx - 4, yy - 15, 8, 15, .6, 1); } });
      [.16, .34, .66, .84].forEach(function (f, k) { var lx = x0 + (x1 - x0) * f, ly = T + 62 + (k % 2) * 34; ln(lx, T, lx, ly - 9, .7, 1); el(lx, ly, 9, 9, 1); });
      var ct = 584;
      rc(x0 + 18, ct, x1 - x0 - 36, 112, 1.4); ln(x0 + 18, ct + 38, x1 - 18, ct + 38, .9, 1);
      for (var xx = x0 + 38; xx < x1 - 56; xx += 40) { poly([[xx, ct + 32], [xx + 5, ct + 22], [xx + 12, ct + 18], [xx + 19, ct + 22], [xx + 24, ct + 32]], 1, .9); el(xx + 12, ct + 32, 13, 3, .8, 0, 2 * PI, 1); }
      var f0 = 698;
      for (var k = -7; k < 9; k++) { var sx = cx + k * 36, ex = sx + k * 20; if (sx > x0 + 6 && sx < x1 - 6) ln(sx, f0, Math.max(x0 + 6, Math.min(x1 - 6, ex)), B - 4, .5, 1); }
      [716, 742, 772].forEach(function (yy) { ln(x0 + 6, yy, x1 - 6, yy, .5, 1); });
      if (hinge == 'left') { ln(x0, T, x0 + 32, T + 24, 1.3); ln(x0 + 32, T + 24, x0 + 32, B - 14, 1.3); ln(x0 + 32, B - 14, x0, B, 1.3); shadeV(x0 + 16, T + 30, B - 30, 22); }
      else { ln(x1, T, x1 - 32, T + 24, 1.3); ln(x1 - 32, T + 24, x1 - 32, B - 14, 1.3); ln(x1 - 32, B - 14, x1, B, 1.3); shadeV(x1 - 16, T + 30, B - 30, 22); }
    }
    glass(92, 362); door(362, 670, 'right'); door(730, 1038, 'left'); glass(1038, 1308);
    for (var k = 0; k < 24; k++) { var x = 30 + k * 56 + J(8); ln(x, G + 50 + J(4), x + 30 + J(6), G + 50 + J(4), .5, 1); }

    return '<svg class="sic-facade-svg" viewBox="-10 20 1420 860" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Le Sicilianedde – Via Ferdinando Fuga 3A-3B">' +
      '<defs>' +
      '<filter id="sicPencil" x="-2%" y="-2%" width="104%" height="104%"><feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" seed="3" result="n"/><feDisplacementMap in="SourceGraphic" in2="n" scale="3" xChannelSelector="R" yChannelSelector="G" result="d"/><feTurbulence type="fractalNoise" baseFrequency="1.6" numOctaves="1" seed="8" result="g"/><feColorMatrix in="g" type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0 -1.5 1.6" result="gm"/><feComposite in="d" in2="gm" operator="in"/></filter>' +
      '<filter id="sicChalk" x="-5%" y="-5%" width="110%" height="110%"><feTurbulence type="fractalNoise" baseFrequency="1.1" numOctaves="2" seed="5" result="g"/><feColorMatrix in="g" type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  0 0 0 -3 1.55" result="gm"/><feGaussianBlur in="SourceGraphic" stdDeviation="2.5" result="b"/><feComposite in="b" in2="gm" operator="in"/></filter>' +
      '</defs>' +
      '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">' +
      '<g fill="#1a5e9c" stroke="none" filter="url(#sicPencil)" opacity=".95">' + FL.join('') + '</g>' +
      '<g filter="url(#sicChalk)" opacity=".38">' + SH.join('') + '</g>' +
      '<g filter="url(#sicPencil)">' + L1.join('') + TX.join('') + '</g>' +
      '</g></svg>';
  }
  var svg;
  function run() {
    var els = document.querySelectorAll('[data-sic-facade]:not([data-done])');
    if (!els.length) return;
    svg = svg || build();
    for (var i = 0; i < els.length; i++) { els[i].innerHTML = svg; els[i].setAttribute('data-done', '1'); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
